import { render, staticRenderFns } from "./IndexGroups.vue?vue&type=template&id=49bf51b8&"
import script from "./IndexGroups.vue?vue&type=script&lang=ts&"
export * from "./IndexGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports